import React, { useMemo, useState } from "react";
import {Name, Created_at, Active, Options} from "./PropertyCol";

const usePropertyCols = (property, handleSetEditProperty, handleSetDeleteProperty, handleHlandleGetQr, handleReceiptPropertyModal) => {


    return useMemo(() => [
        {
            Header: "No",
            accessor: "id",
            disableFilters: true,
            Cell: (cellProps) => {
                return <Name {...cellProps} />;
            },
        },
        {
            Header: "Concepto",
            accessor: "concept",
            filterable: true,
            filterRemote: true,
            Cell: (cellProps) => {
                return <Name {...cellProps} />;
            },
        },
        {
            Header: "Descripción",
            accessor: "description",
            disableFilters: true,
            Cell: (cellProps) => {
                return <Name {...cellProps} />;
            },
        },
        {
            Header: "Cantidad",
            accessor: "quantity",
            disableFilters: true,
            Cell: (cellProps) => {
                return <Name {...cellProps} />;
            },
        },
        {
            Header: "Ubicación",
            accessor: "location",
            disableFilters: true,
            Cell: (cellProps) => {
                return <Name {...cellProps} />;
            },
        },
        {
            Header: "No. Inventario",
            accessor: "num_inventory",
            disableFilters: true,
            Cell: (cellProps) => {
                return <Name {...cellProps} />;
            },
        },
        {
            Header: "Fecha Alta",
            accessor: "created_at_f",
            disableFilters: true,
            Cell: (cellProps) => {
                return <Created_at {...cellProps} />;
            },
        },
        {
            Header: "Status",
            accessor: "status",
            disableFilters: true,
            Cell: (cellProps) => {
                return <Active {...cellProps} />;
            },
        },
        {
            Header: "Opciones",
            accessor: "options",
            disableFilters: true,
            Cell: (cellProps) => {
                return <Options {...cellProps} property={property} onEdit={handleSetEditProperty} onDelete={handleSetDeleteProperty} onHlandleGetQr={handleHlandleGetQr} onReceiptPropertyModal={handleReceiptPropertyModal} />;
            },
        }
    ],[]);  
}
export {usePropertyCols}